import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons";
import {countDays} from '../../../../../functions/Functions';

class RequestDescription extends React.Component {
    render() {
        const {problem_content, id, category, city, message, handleChange, ifSent, date} = this.props
        
        return(
            <div className='col-sm-6 requestDescriptionContainer'>
                <h1 className="stdHeader">Nowa prośba o wycenę</h1>
                <ProblemInfo 
                    date={date}
                    city={city} 
                    id={id}
                    category={category}
                />
                <ProblemContainer problem_content={problem_content}/>
                <LaywerChatInput 
                    ifSent={ifSent}
                    message={message}
                    handleChange={handleChange}
                />
            </div>
        )
    }
}

class ProblemInfo extends React.Component {
    render() {
        const {date, city, id, category} = this.props;
        
        return (
            <>
                <SentDate date={date}/>
                <div className="details">
                    <img src='../../media/img/ghost.png' alt="zdjęcie profilowe użytkownika" />
                    <b>Nowy użytkownik - numer identyfikacyjny sprawy ({id})</b>
                    <br/>
                    <Location city={city}/>
                    <Category category={category} />
                </div>
            </>
        )
    }
}

class SentDate extends React.Component {
    render() {
        const {date} = this.props
        let days = countDays(date)
        let weekday = new Date(date*1000).toLocaleString(window.navigator.language, {weekday: 'long'});
        let time = (new Date(date*1000).toLocaleTimeString([], {hourCycle: 'h23'})).slice(0,5)
        let day = new Date(date*1000).toLocaleDateString();
        let weeksPhrase = '';
        let daysPhrase = '';
        let weeks = Math.floor(days/7);
        let daysLeft = days - weeks*7;

        if(weeks > 0) {
            let word = ''
            if (weeks === 1) {
                word = 'tydzień'
            } else if ((String(weeks).slice(-1)) === ('2' || '3' || '4')) {
                word = 'tygodnie'
            } else {
                word = 'tygodni'
            }
            weeksPhrase = `${weeks} ${word}`
        }
        if (daysLeft > 0) {
            let word = '';
            if (daysLeft === 1) {
                word = 'dzień'
            } else {
                word = 'dni'
            }
            daysPhrase = `${daysLeft} ${word}`
        }

        return (
            <div className="sentInfo">
                Wysłano {weeksPhrase} {daysPhrase} temu&nbsp;
                <span className="gray">
                    ({time}, {weekday}, {day})
                </span>
            </div>
        )
    }
}

class Location extends React.Component {
    render() {
        const {city} = this.props
        if(city)
        return (
            <span>
                Zlokalizowany w mieście <span className='text-primary ml-8'>{city}</span>
            </span>
        )
    }
}

class Category extends React.Component {
    render() {
        const {category} = this.props
        if(category)
        return (
            <span className="description">
                Potrzebuje pomocy w sprawie 
                <span className='text-primary ml-8'>{category.name}</span>
            </span>
        )
    }
}

class ProblemContainer extends React.Component {
    render() {
        const {problem_content} = this.props
        return (
            <div className="bubbleContainer">
                <div className="dziubek"></div>
                <div className="bubble">
                    <span className="line-height1-5">
                        <b>Problem:</b>
                        {problem_content}
                    </span>
                </div>
            </div>
        )
    }
}

class LaywerChatInput extends React.Component {
    render() {
        const {ifSent, message, handleChange} = this.props
        if(!ifSent)
        return(
            <div className="laywerChatContainer">
                <div className="input-group">
                    <div className="input-group-addon">
                        <FontAwesomeIcon icon={faEnvelope} className="fa-envelope"/>
                    </div>
                    <input type="text" value={message} onChange={handleChange} className="respond-input" placeholder='Okienko do korespondencji z Klientem'/>
                </div> 
            </div>
        )
    }
}

export default RequestDescription;